module.exports = __webpack_public_path__ + "img/03.99a022d6.jpg";